import { Checkbox, Col, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { MdCancel } from "react-icons/md";
import { useParams } from "react-router-dom";
import styles from "../../ProductsByCategory.module.scss";

export const DesktopFilter = ({ desktopFilters, setDesktopFilters, desktopFilterUIStates }) => {
    const [filtersSelected, setFiltersSelected] = useState([]);
    const { slug } = useParams();

    useEffect(() => {
        let label = [];
        // store array of objects in label array
        for (let key in desktopFilters) {
            if (desktopFilters.hasOwnProperty(key)) {
                const element = desktopFilters[key];
                label = [...label, ...element];
            }
        }
        setFiltersSelected(label);

        // format desktop filters and extract the slugs by splitting the string by /

        setDesktopFilters(desktopFilters);
    }, [desktopFilters, setDesktopFilters]);

    const handleCrossBtnClick = (item) => {
        // remove the item from the selected filters
        const newFiltersSelected = filtersSelected.filter((filter) => filter !== item);
        setFiltersSelected(newFiltersSelected);

        // remove the item from the desktop filters also
        for (const key in desktopFilters) {
            if (desktopFilters.hasOwnProperty(key)) {
                const element = desktopFilters[key];
                if (element.includes(item)) {
                    const newDesktopFilters = {
                        ...desktopFilters,
                        [key]: element.filter((filter) => filter !== item),
                    };
                    setDesktopFilters(newDesktopFilters);
                }
            }
        }
    };

    // on slug change reset the desktop filters
    useEffect(() => {
        setFiltersSelected([]);
        setDesktopFilters({
            discounts_and_offer: [],
            brands: [],
        });
    }, [slug]);

    return (
        <>
            <Row gutter={[20, 20]}>
                <Col flex={"14.28571428%"}>
                    <Select
                        style={{
                            width: "100%",
                        }}
                        placeholder={
                            <div
                                style={{
                                    color: "black",
                                    fontWeight: "600",
                                }}
                            >
                                Discount
                            </div>
                        }
                        className="custom_filter_select"
                        dropdownRender={() => (
                            <Checkbox.Group
                                style={{
                                    width: "100%",
                                }}
                                onChange={(checkedValues) => {
                                    setDesktopFilters((prev) => ({
                                        ...prev,
                                        discounts_and_offer: checkedValues,
                                    }));
                                }}
                                value={desktopFilters.discounts_and_offer}
                            >
                                <Row>
                                    {[
                                        {
                                            label: "Offers & discounts",
                                            value: "offers_and_discounts",
                                            amount: desktopFilterUIStates?.discounts_and_offer_count,
                                        },
                                    ].map((item, index) => (
                                        <Col span={24} key={index}>
                                            <div className={styles.dt_filter_select}>
                                                <Checkbox value={`${item.label}/${item.value}`}>{item.label}</Checkbox>
                                                <div
                                                    style={{
                                                        color: "black",
                                                    }}
                                                >
                                                    ({item.amount})
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Checkbox.Group>
                        )}
                    />
                </Col>
                <Col flex={"14.28571428%"}>
                    <Select
                        style={{
                            width: "100%",
                        }}
                        placeholder={
                            <div
                                style={{
                                    color: "black",
                                    fontWeight: "600",
                                }}
                            >
                                Brands
                            </div>
                        }
                        className="custom_filter_select"
                        dropdownRender={() => (
                            <Checkbox.Group
                                style={{
                                    width: "100%",
                                }}
                                onChange={(checkedValues) => {
                                    setDesktopFilters((prev) => ({
                                        ...prev,
                                        brands: checkedValues,
                                    }));
                                }}
                                value={desktopFilters.brands}
                            >
                                <Row>
                                    {desktopFilterUIStates?.brands.map((item, index) => (
                                        <Col span={24} key={index}>
                                            <div className={styles.dt_filter_select}>
                                                <Checkbox value={`${item.brand__name}/${item.brand__id}`}>{item.brand__name}</Checkbox>
                                                <div
                                                    style={{
                                                        color: "black",
                                                    }}
                                                >
                                                    ({item.dcount})
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Checkbox.Group>
                        )}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    {filtersSelected.length > 0 && (
                        <div className={styles.desktop_filter_selected_items_wrapper}>
                            {filtersSelected.map((item, index) => (
                                <div className={styles.desktop_filter_selected_items} key={index}>
                                    {item.split("/")[0]}
                                    <MdCancel
                                        size={18}
                                        onClick={() => {
                                            handleCrossBtnClick(item);
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </Col>
            </Row>
        </>
    );
};